import React, { memo } from "react";
import { Input, Label, InputWrapper, Error, CustomIcon } from "./Theme";
import KeyboardIcon from "@material-ui/icons/Keyboard";
import { ReactComponent as DateIconActive } from "assets/icons/CustomDataIcon.svg";
import { ReactComponent as DateIconUnActive } from "assets/icons/CustomDateIconGray.svg";

export const InputField = memo(
  ({
    type,
    placeholder,
    label,
    title,
    isOptional,
    formik,
    message,
    ref,
    isDisabled,
    style,
    styleWrapper,
    labelStyle,
    titleStyle,
    error,
    flexDirection,
    Wrapper,
    name,
    setOpenKeyboard,
    openKeyboard,
    isDate,
    mandatory,
    defaultValue,
    ...rest
  }) => {
    const isName = name && formik?.getFieldProps(name);
    const labelText = label || title;
    const labelSt = labelStyle || titleStyle;
    return (
      <InputWrapper style={Wrapper}>
        {labelText && <Label style={labelSt} mandatory={mandatory}>
          <span>{labelText}</span>
          {mandatory && <label style={{ fontWeight: "500", color: "red" }}>
            {" *"}
          </label>}
          {isOptional && <span>{`(optional)`}</span>}
        </Label>}
        <div style={styleWrapper}>
          <Input
            ref={ref}
            type={type}
            placeholder={placeholder}
            error={error}
            {...rest}
            disabled={isDisabled}
            style={style}
            isDisabled={isDisabled}
            {...isName}
            defaultValue={defaultValue}
          />
          {/* If we wanna open the windows keybord */}
          {name === "hebrew_name" && (
            <KeyboardIcon
              fontSize="large"
              style={{
                cursor: "pointer",
                alignSelf: "center",
                marginRight: "5px",
                position: "absolute",
                right: "2%",
                top: "26%",
              }}
              onClick={() => {
                setOpenKeyboard(!openKeyboard);
              }}
            />
          )}
          {isDate && (
            <CustomIcon role="img" aria-label="calendar">
              <DateIconUnActive />
            </CustomIcon>
          )}

          {error && <Error>{message}</Error>}
        </div>
      </InputWrapper>
    );
  }
);
